import { map } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DomainDataFacade } from '@mitsubishi/core';
import { SelectModule } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-brand-selection',
  templateUrl: './brand-selection.component.html',
  styleUrls: ['./brand-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, SelectModule],
})
export class BrandSelectionComponent {
  @Input() bindValue = 'id';
  @Input() selectedBrand: number[] | number | undefined | null;
  @Input() multiple = true;
  @Input() acceptedValues: number[] | undefined;

  @Output() brandChanged = new EventEmitter<any>();

  private commonDataFacade = inject(DomainDataFacade);
  brands$ = this.commonDataFacade.brands$.pipe(
    map(brands => {
      if (!this.acceptedValues) {
        return brands;
      }

      return brands.filter(brand => this.acceptedValues?.includes(brand.id));
    })
  );

  onBrandSelectionChange() {
    this.brandChanged.emit(this.selectedBrand);
  }
}
